export const colorize = (data) => {
  return data.map(segment => {
    segment['itemStyle'] = {'color': segment.color}
    return segment
  })
}